module.exports = __webpack_public_path__ + "img/lock-locked.f4152f7a.svg";